import script from "./HolidayForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./HolidayForm.vue?vue&type=script&setup=true&lang=ts"

import "./HolidayForm.vue?vue&type=style&index=0&id=79ba1cec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ba1cec"]])

export default __exports__